<template>
  <section class="retrospective">
    <div
      class="retrospective__title"
      :style="{ fontSize: titleFontSize, lineHeight: titleLineHeight }"
    >
      {{ sectionTitle ? sectionTitle : $t("subscriptions.retrospective.title") }}
    </div>
    <div class="retrospective__content">
      <div class="image-container">
        <div class="image image-before">
          <img :src="`${mediaBaseUrl}subscriptions/before-image.png`" />
        </div>
        <div class="image image-after">
          <img :src="`${mediaBaseUrl}subscriptions/after-image.png`" />
        </div>
        <div class="bullet">
          <div class="bullet__text">
            {{ $t("subscriptions.retrospective.bulletText") }}
          </div>
        </div>
      </div>
      <div class="text">
        {{ $t("subscriptions.retrospective.text") }}
      </div>
    </div>
    <slot></slot>
  </section>
</template>

<script>
export default {
  inject: ["mediaBaseUrl"],
  props: {
    reviews: {
      type: Array,
      default: [],
    },
    sectionTitle: {
      type: String,
      required: false,
    },
    titleFontSize: {
      type: String,
      default: "24px",
    },
    titleLineHeight: {
      type: String,
      default: "33.6px",
    },
  },
};
</script>

<style scoped lang="sass">
.retrospective
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  gap: 24px
  padding: 48px 16px 32px !important

  &__title
    font-size: 24px
    font-weight: 700
    line-height: 33.6px
    text-align: center
    color: #1B2A3F

  &__content
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

    .image-container
      width: 100%
      display: flex
      gap: 7.6px
      position: relative
      padding-bottom: 20px
      margin-bottom: 12px

      .image
        width: 164px
        height: 244px
        border-radius: 16px

        img
          width: 100%

        &-before
          &:lang(ar)
            transform: rotate(4deg)

        &-after
          &:lang(ar)
            transform: rotate(-4deg)

    .bullet
      width: 100%
      position: absolute
      bottom: 0%
      display: flex
      align-items: center
      justify-content: center

      &__text
        padding: 8px 16px
        border-radius: 40px
        background: #FCF3FF
        font-size: 20px
        font-weight: 700
        line-height: 28px
        text-align: center
        color: #1B2A3F

    .text
      font-size: 10px
      font-weight: 400
      line-height: 15px
      text-align: center
      color: #000000
      max-width: 293px
</style>